import { IDataStore } from '@/services/dataStore/IDataStore'

/*
  DEPRECATED - TODO: re-generate static data or remove entirely.
*/
export class StaticDataStore implements IDataStore {
  getRemedies = async () => []
  getRemedy = async (_remedyKey: string) => undefined
  getRemedyCategories = async () => []
  getCommentCategories = async () => []
  getCommentCategoryIcons = async () => []

  getEffects = async () => []
  getEffect = async (_effectKey: string) => undefined
  getCosts = async () => []

  getDataLayers = async () => []
  getDataLayer = async (_dataLayerKey: string) => undefined
  getLayerPacks = async () => []

  getTutorialCopy = async () => undefined
}
